export class WebConfiguration {
  local: boolean;
  production: boolean;
  appTitle: string;
  ppeApi: string;
  mpatApi: string;
  dlpApi: string;
  uriBootstrap: string;
  googleAnalyticsKey: string;
  idleTimeoutSeconds: number;
}
